import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson = () => {
  let initData: any = {
    table: "mpoint_order",
    list_id: "mpoint_order_comp_list",
    x_column_list_arr: [
      { "key": "a_date", "name": "거래일", "width": "110", "is_show": "1" },
      // {"key":"a_amount","name":"포인트","width":"100","is_show":"1"},
      // {"key":"a_sort","name":"구분1","width":"100","is_show":"1"},
      // {"key":"a_sort_detail","name":"구분","width":"100","is_show":"1"},
      { "key": "a_title", "name": "제목", "width": "250", "is_show": "1" },
      { "key": "a_price_sum", "name": "금액", "width": "100", "is_show": "1" },
      { "key": "a_is_pay", "name": "완료여부", "width": "100", "is_show": "1" },
      { "key": "row_view_manage", "name": "관리", "width": "160", "is_show": "1" },
      { "key": "a_pay_memo", "name": "결제메모", "width": "160", "is_show": "1" },
      { "key": "a_create_date", "name": "작성", "width": "160", "is_show": "1" },
      { "key": "a_update_date", "name": "수정", "width": "100", "is_show": "1" },
    ],
    list_opt_origin: {
      'now_page': 1,
      'num_per_page': 30,
      'order_id':'a_date DESC, a_create_date',
      'order_type': '',
      's_date_type': '',
      's_start_date': '',
      's_end_date': '',
      'sc': {},
      "is_add_idx_info":"1",
    },
    order_id_col_arr: [
      { "value": "", "text": "없음" },
    ]
  };
  initData.pri_col_arr = ["a_ymd", "a_seq"];
  const xColumnArr: any = XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.select_arr["a_is_pay"]=[
    { "value": "1", "text": "완료" },
    { "value": "", "text": "미완료" },
  ];

  return xColumnArr;
};

export default getXcolumnJson;